module.exports = __webpack_public_path__ + "static/img/WEIS.16825b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/WEIS.png
// module id = DnQf
// module chunks = 34